"use client";
import Layout1 from "./ProductCategoryLayout/Layout1";
import Layout2 from "./ProductCategoryLayout/Layout2";
import Layout3 from "./ProductCategoryLayout/Layout3";
import Layout4 from "./ProductCategoryLayout/Layout4";
import Layout5 from "./ProductCategoryLayout/Layout5";
interface ProductCategoryProps {
  data: {
    id: number;
    title: string;
    description: string;
    isLive: boolean;
    layout: string;
    useH1Tag: boolean;
    Card: {
      id: number;
      title: string;
      description: string;
      href: string;
      screenDisplay: boolean;
      badge?: string;
      image: {
        data: {
          attributes: {
            url: string;
            alternativeText: string | null;
          };
        };
      };
    }[];
  };
}

export default function ProductCategory({ data }: ProductCategoryProps) {
  // console.log("data.layout", data.layout);

  if (!data?.isLive) return null;

  if (data.layout === "GRID_STANDARD") {
    return <Layout1 data={data} />;
  } else if (data.layout === "CAROUSEL_SPOTLIGHT") {
    return <Layout2 data={data} />;
  } else if (data.layout === "FEATURED_HERO") {
    return <Layout3 data={data} />;
  } else if (data.layout === "CAROUSEL_COMPACT") {
    return <Layout4 data={data} />;
  } else if (data.layout === "MASONRY_VISUAL") {
    return <Layout5 data={data} />;
  } else {
    return <Layout1 data={data} />;
  }
}
